import { io, Socket } from "socket.io-client";

const socket: Socket = io(process.env.REACT_APP_SRV_URL, {
  path: process.env.REACT_APP_SOCKET_PATH,
  autoConnect: false,
});

export default socket;
